export enum OverrideType {
  SICK_COVER = "sick_cover",
  LEAVE_COVER = "leave_cover",
  SWAP = "swap",
  EXTRA_STAFFING = "extra_staffing",
  EMERGENCY = "emergency",
}

export type OverrideStatus =
  | "pending"
  | "approved"
  | "rejected"
  | "cancelled"
  | "completed";

export interface ScheduleOverride {
  id: string;
  covering_employee: number;
  covering_employee_name: string;
  covered_employee: number | null;
  covered_employee_name: string | null;
  shift_location: string;
  covered_assignment: string | null;
  override_date: string;
  override_type: OverrideType;
  status: OverrideStatus;
  reason: string | null;
  shift_start: string | null;
  shift_end: string | null;
  requested_by: string | null;
  requested_at: string;
  approved_by: string | null;
  approved_at: string | null;
  date_created: string;
  date_updated: string;
}

export interface ScheduleOverridesResponse {
  count: number;
  pages: number;
  results: ScheduleOverride[];
}
